import React from 'react';
// Material UI
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import { theme as CustomTheme } from 'theme';

const StyledSwitch = withStyles((theme) => ({
  root: {
    width: 46,
    height: 23,
    padding: 0,
    marginBottom: 0,
  },
  switchBase: {
    marginLeft: 2,
    padding: 1,
    '&$disabled': {
      color: CustomTheme.colors.primary.red,
      '& + $track': {
        backgroundColor: CustomTheme.colors.primary.red,
        opacity: 1,
        border: 'none',
      },
    },
    '&$checked': {
      transform: 'translateX(22px)',
      color: CustomTheme.colors.primary.white,
      '& + $track': {
        backgroundColor: CustomTheme.colors.primary.red,
        opacity: 1,
        border: 'none',
      },
    },
    '&$checked$disabled': {
      transform: 'initial',
      color: CustomTheme.colors.primary.white,
      cursor: 'default',
      opacity: 0.2,
      '& + $track': {
        backgroundColor: CustomTheme.colors.primary.red,
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: CustomTheme.colors.primary.white,
    },
  },
  thumb: {
    marginTop: 1.5,
    width: 18,
    height: 18,
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: '#a5a9c7',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  input: {
    position: 'absolute !important',
  },
  disabled: {},
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        input: classes.input,
        checked: classes.checked,
        disabled: classes.disabled,
      }}
      {...props}
    />
  );
});

const SdmSwitch = (props) => {
  return <StyledSwitch {...props} />;
};

export { SdmSwitch };
